import mixins from "vue-typed-mixins";
import requestPasswordMixin from "./requestPasswordMixin";
const Button = () => import("@/components/Button.vue");
const TextField = () => import("@/components/TextField.vue");
const Alert = () => import("@/components/Alert.vue");
export default mixins(requestPasswordMixin).extend({
    components: { Button, TextField, Alert },
    props: {
        phone: {
            type: [Number, String],
            default: "",
        },
    },
    methods: {},
});
